import axios from 'axios';
import { message } from 'ant-design-vue';
import store from '../store'
import router, { resetRouter } from '@/router'
// 创建 Axios 实例
const api = axios.create({
    // baseURL: localStorage.getItem('baseURL') || 'http://127.0.0.1:3000',
    // baseURL: "",
    // baseURL: localStorage.getItem('baseURL') || 'http://124.222.64.43',
    timeout: 15 * 1000, // 设置请求超时时间
    headers: {
        'Content-Type': 'application/json;charset=utf-8'
    },
});

// 请求拦截器
api.interceptors.request.use(
    (config) => {
        const baseURL = store.state.config.baseURL || 'http://127.0.0.1:3000'
        config.baseURL = baseURL
        // const headers = config.headers;
        const token = localStorage.getItem('token')
        // 在发送请求之前做一些处理，例如添加请求头等
        config.headers.Authorization = token
        if (store.state.user.userinfo && store.state.user.userinfo.role_id == -1) {
            const project_id = store.state.config.project_id || ''
            config.headers.projectid = project_id
        }
        // const contentType = headers['Content-Type'];
        // if (contentType) {
        //     // 根据传入的 Content-Type 设置请求头部
        //     console.log('根据传入的 Content-Type 设置请求头部', contentType)
        //     config.headers['Content-Type'] = contentType;
        // }
        return config;
    },
    error => {
        // 请求错误时的处理
        console.error('请求发生错误:', error);
        return Promise.reject(error);
    }
);

// 响应拦截器
api.interceptors.response.use(
    response => {
        // 对响应数据进行处理
        const data = response.data;
        // 这里可以根据后端返回的数据结构进行逻辑判断和处理
        if (data.status == 0) {
            return data;
        } else {
            message.error(data.message || data.msg || '服务器开小差了');
        }
    },
    error => {
        console.log('进error了')
        //重新登录的逻辑
        if (error.response && error.response.status === 401) {
            store.dispatch('Loginout', { router: router, resetRouter: resetRouter })
        }
        // 响应错误时的处理
        if (error.response) {
            // 获取响应数据
            const response = error.response;
            const data = response.data;
            console.log('响应发生错误:', data);
            if (data.message && data.message == 'Connection lost: The server closed the connection.') {
                message.error('数据库连接异常，请检查');
            } else {
                message.error(data.message || data.msg || error.response.status + '');
            }

        } else {
            console.log('请求发生错误:', error.message);
            if (error.message && error.message == 'Network Error') {
                message.error('主机与服务器连接异常，请检查');
            } else {
                message.error('请求发生错误:' + error.message);
            }

        }
        return Promise.reject(error.response ? error.response : error);
    }
);

export default api;